import instance from "../config";

// metodo para candidatos
export const getConteo = () => {
  return instance.get("/conteo");
};

// metodo para registro de votos
export const crearConteo = (candidatoId, lugar, mesa, votos) => {
  return instance.post("/conteo", { candidatoId, lugar, mesa, votos });
};

// metodo para editar (lanza el error para que el modal muestre el mensaje del backend)
export const editarconteo = async (id, candidatoId, lugar, mesa, votos) => {
  const { data } = await instance.put(`/conteo?id=${id}`, {
    candidatoId,
    lugar,
    mesa,
    votos,
  });
  return data;
};

// metodo para eliminar
export const eliminarvotos = async (id) => {
  try {
    const { data } = await instance.delete(`/conteo?id=${id}`);
    return data;
  } catch (error) {
    return error;
  }
};

// metodo para filtra general
export const filtrovotos = async (params) => {
  try {
    console.log(params);
    const { data } = await instance.get("/conteo/filtro", { params });
    return data;
  } catch (error) {
    return error;
  }
};